import { render, staticRenderFns } from "./UserPin.vue?vue&type=template&id=32a12946&scoped=true"
import script from "./UserPin.vue?vue&type=script&lang=js"
export * from "./UserPin.vue?vue&type=script&lang=js"
import style0 from "./UserPin.vue?vue&type=style&index=0&id=32a12946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a12946",
  null
  
)

export default component.exports